import React, {ReactElement} from 'react'
import {styled} from '@mui/material';
import {selectClasses, SelectProps, SelectRootSlotProps} from '@mui/base/Select';
import {OptionProps} from '@mui/base/Option';
import {SVGS} from '../../../../../assets/images';
import Listbox, { Option } from '../../../listbox';
import {Select as BaseSelect} from '@mui/base/Select/Select';

const StyledGridDropdownOption = styled(Option)`
  display: flex;
  align-items: center;
  gap: 0;
  min-width: 0;
  min-height: 48px;
  padding: 0 24px !important;
  box-sizing: border-box;
  overflow: hidden;

  & > span {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const GridDropdownListbox = styled(Listbox)`
  max-height: 18rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
`;

const StyledButton = styled('button', { shouldForwardProp: () => true })(
    () => `
margin: 0;
padding: 8px 16px !important;
width: 100%;
height: 100%;
box-sizing: border-box;
position: relative;
background: transparent;
display: grid !important;
grid-template-columns: minmax(0, 1fr) auto;
align-items: center;
box-shadow: none !important;
border: none !important;
border-color: transparent !important;
border-radius 0 !important;
text-align: start;
color: var(--text-primary);

&.${selectClasses.expanded} {
    color: var(--text-primary);
    border-color: transparent !important;

    svg {
        path {
            fill: var(--text-primary);
        }
    }
}

&.${selectClasses.focusVisible} {
    outline: 0;
    border-color: transparent !important;
}

svg {
    align-self: center;
    justify-self: flex-end;
    width: auto;
    path {
        fill: var(--text-primary);
    }
}

span {
    min-width: 0;
    align-self: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


font: inherit;
`);

const Popup = styled('div')`
  z-index: 1000;
  max-width: min(28rem, calc(100vw - 32px));
  max-height: 18rem;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 0.4211rem;
  background: var(--background-additional);
`;

const CustomButton = React.forwardRef(function CustomButton<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean,
>(
    props: SelectRootSlotProps<TValue, Multiple>,
    ref: React.ForwardedRef<HTMLButtonElement>,
) {
    const {ownerState: _ownerState, ...other} = props;
    void _ownerState;

    return (
        <StyledButton type="button" {...other} ref={ref}>
            <span>{other.children}</span>
            <SVGS.DropdownIcon/>
        </StyledButton>
    );
});

const GridDropdownOption = React.forwardRef<
    HTMLLIElement,
    OptionProps<unknown>
>(function GridDropdownOption(props, ref) {
    const { children, ...other } = props;

    return (
        <StyledGridDropdownOption {...other} ref={ref}>
            <span>{children}</span>
        </StyledGridDropdownOption>
    );
});

const Select = React.forwardRef(function Select<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean,
>(props: SelectProps<TValue, Multiple>, ref: React.ForwardedRef<HTMLButtonElement>) {
    const slots: SelectProps<TValue, Multiple>['slots'] = {
        root: CustomButton,
        listbox: GridDropdownListbox,
        popup: Popup,
        ...props.slots,
    };

    return <BaseSelect {...props} ref={ref} slots={slots}/>;
}) as <TValue extends NonNullable<unknown>, Multiple extends boolean>(
    props: SelectProps<TValue, Multiple> & React.RefAttributes<HTMLButtonElement>,
) => ReactElement;

export { Select as GridDropdown };
export { GridDropdownOption };
